import React, { Component } from "react"

import Nav from "../components/shared/Nav"
import SiteHeader from "../components/shared/SiteHeader"
import { Grid, Responsive } from "semantic-ui-react"
import { connect } from "react-redux"

class ApplicationLayout extends Component {
  render() {
    const { children, mobileMenuOpen, mainClass = "" } = this.props
    return (
      <div className="flex">
        <div className="hidden md:block">
          <Nav />
        </div>
        <div className={"main flex-grow-1 " + mainClass}>
          <div>
            <SiteHeader />
          </div>
          <div stretched className="content mx-5">
            {children}
          </div>
        </div>
      </div>
    )
  }
} // class ApplicationLayout

const mapStateToProps = (state) => ({
  mobileMenuOpen: state.application.mobileMenuOpen
})

export default connect(mapStateToProps)(ApplicationLayout)
